import moment from 'moment';

export const calculateTotals = (data) => {
  const firstDataset = Object.keys(data)[0];
  const dates = Object.keys(data[firstDataset]);

  return dates.map((date) => Object.values(data).reduce((sum, range) => sum + range[date].company_count, 0));
};

const hasKey = (data, key) => data != null && Object.prototype.hasOwnProperty.call(data, key);

export const getCompanyCountsMap = (data, key) =>
  hasKey(data, key) ? Object.values(data[key]).map((item) => item.company_count) : [];

export const getCompanyIdsMap = (data, key) =>
  hasKey(data, key) ? Object.values(data[key]).map((item) => item.company_ids) : [];

export const getPeriodsMap = (data, key) => (hasKey(data, key) ? Object.keys(data[key]) : []);

export const generateMonthRange = (monthRange) => {
  const startDate = moment(monthRange[0].format('YYYY-MM'), 'YYYY-MM');
  const endDate = moment(monthRange[1].format('YYYY-MM'), 'YYYY-MM');
  const range = [];

  while (startDate.isSameOrBefore(endDate)) {
    range.push(startDate.format('MMM YYYY'));
    startDate.add(1, 'month');
  }

  return range;
};

export const countAndPercentageLabelFormatter = (value, total) => {
  if (value === 0) {
    return null;
  }

  const percentage = ((value / total) * 100).toFixed(2);

  return `${value} (${percentage}%)`;
};
